import { connect, mapProps, mapReadPretty } from "@formily/react";
import { Input as AntdInput, Button } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";

const MultipleLinksInputBase = (props: any) => {
  const { value, onChange, ...restProps } = props;
  const [links, setLinks] = useState<string[]>([]);

  // Parse initial value
  useEffect(() => {
    if (value) {
      try {
        const parsed = typeof value === "string" ? JSON.parse(value) : value;
        if (Array.isArray(parsed)) {
          setLinks(parsed.length > 0 ? parsed : [""]);
        } else if (typeof parsed === "string" && parsed) {
          setLinks([parsed]);
        } else {
          setLinks([""]);
        }
      } catch {
        // If not JSON, treat as single string
        if (typeof value === "string" && value) {
          setLinks([value]);
        } else {
          setLinks([""]);
        }
      }
    } else {
      setLinks([""]);
    }
  }, [value]);

  const handleLinkChange = (index: number, newValue: string) => {
    const newLinks = [...links];
    newLinks[index] = newValue;
    setLinks(newLinks);
    // Store as JSON string array
    const filteredLinks = newLinks.filter(link => link.trim() !== "");
    onChange?.(filteredLinks.length > 0 ? JSON.stringify(filteredLinks) : "");
  };

  const handleAddLink = () => {
    const newLinks = [...links, ""];
    setLinks(newLinks);
  };

  const handleRemoveLink = (index: number) => {
    if (links.length === 1) {
      setLinks([""]);
      onChange?.("");
    } else {
      const newLinks = links.filter((_, i) => i !== index);
      setLinks(newLinks);
      const filteredLinks = newLinks.filter(link => link.trim() !== "");
      onChange?.(filteredLinks.length > 0 ? JSON.stringify(filteredLinks) : "");
    }
  };

  return (
    <div className="space-y-2">
      {links.map((link, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={`link-${index}-${link}`} className="flex gap-2">
          <AntdInput
            {...restProps}
            type="url"
            placeholder="https://..."
            value={link}
            onChange={e => handleLinkChange(index, e.target.value)}
            style={{ flex: 1 }}
          />
          {links.length > 1 && (
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleRemoveLink(index)}
            />
          )}
        </div>
      ))}
      <Button
        type="dashed"
        onClick={handleAddLink}
        icon={<PlusOutlined />}
        block
      >
        Add Link
      </Button>
    </div>
  );
};

export const CustomMultipleLinksInput = connect(
  MultipleLinksInputBase,
  mapProps(props => {
    return {
      ...props,
    };
  }),
  mapReadPretty((props: any) => {
    const { value } = props;
    if (!value) {
      return <span>-</span>;
    }
    try {
      const parsed = typeof value === "string" ? JSON.parse(value) : value;
      if (Array.isArray(parsed)) {
        return (
          <div>
            {parsed.map((link: string, index: number) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={`parsed-link-${index}-${link}`}>
                <a href={link} target="_blank" rel="noopener noreferrer">
                  {link}
                </a>
              </div>
            ))}
          </div>
        );
      }
      return <span>{value}</span>;
    } catch {
      return <span>{value}</span>;
    }
  })
);
